/**
 * @generated SignedSource<<7a2e3ddc332385c1422d4a2545c74577>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AdminMembersReportOverviewTabStatisticsCardsQuery$variables = {
  id: string;
  startDate?: string | null;
};
export type AdminMembersReportOverviewTabStatisticsCardsQuery$data = {
  readonly node: {
    readonly __typename: "OrganizationMembership";
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"MemberReportEngagementScoreStatisticCardFragment" | "MemberReportEventsAttendedStatisticCardFragment" | "MemberReportProductsRegisteredStatisticCardFragment">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type AdminMembersReportOverviewTabStatisticsCardsQuery = {
  response: AdminMembersReportOverviewTabStatisticsCardsQuery$data;
  variables: AdminMembersReportOverviewTabStatisticsCardsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startDate"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "startDate",
    "variableName": "startDate"
  }
],
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "allTime",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sinceYesterday",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminMembersReportOverviewTabStatisticsCardsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "args": (v4/*: any*/),
                "kind": "FragmentSpread",
                "name": "MemberReportProductsRegisteredStatisticCardFragment"
              },
              {
                "args": (v4/*: any*/),
                "kind": "FragmentSpread",
                "name": "MemberReportEventsAttendedStatisticCardFragment"
              },
              {
                "args": (v4/*: any*/),
                "kind": "FragmentSpread",
                "name": "MemberReportEngagementScoreStatisticCardFragment"
              }
            ],
            "type": "OrganizationMembership",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AdminMembersReportOverviewTabStatisticsCardsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "GenericReportingResponse",
                "kind": "LinkedField",
                "name": "productsRegisteredReport",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "GenericReportingResponse",
                "kind": "LinkedField",
                "name": "eventsAttendedReport",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "GenericReportingResponse",
                "kind": "LinkedField",
                "name": "engagementScoreReport",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              }
            ],
            "type": "OrganizationMembership",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b9f437331a4093279b53108bb046b9df",
    "id": null,
    "metadata": {},
    "name": "AdminMembersReportOverviewTabStatisticsCardsQuery",
    "operationKind": "query",
    "text": "query AdminMembersReportOverviewTabStatisticsCardsQuery(\n  $id: ID!\n  $startDate: String\n) {\n  node(id: $id) {\n    __typename\n    ... on OrganizationMembership {\n      id\n      ...MemberReportProductsRegisteredStatisticCardFragment_4sOHZa\n      ...MemberReportEventsAttendedStatisticCardFragment_4sOHZa\n      ...MemberReportEngagementScoreStatisticCardFragment_4sOHZa\n    }\n    id\n  }\n}\n\nfragment MemberReportEngagementScoreStatisticCardFragment_4sOHZa on OrganizationMembership {\n  engagementScoreReport(startDate: $startDate) {\n    allTime\n    sinceYesterday\n  }\n}\n\nfragment MemberReportEventsAttendedStatisticCardFragment_4sOHZa on OrganizationMembership {\n  eventsAttendedReport(startDate: $startDate) {\n    allTime\n    sinceYesterday\n  }\n}\n\nfragment MemberReportProductsRegisteredStatisticCardFragment_4sOHZa on OrganizationMembership {\n  productsRegisteredReport(startDate: $startDate) {\n    allTime\n    sinceYesterday\n  }\n}\n"
  }
};
})();

(node as any).hash = "f73a9e2037f4038628fcc4b397e22370";

export default node;
